import {Delete, Edit} from "@mui/icons-material"
import AddIcon from "@mui/icons-material/Add"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
    Button,
    Grid,
    Menu,
    MenuItem,
    IconButton,
    Typography,
} from "@mui/material"
import React, {useContext, useRef, useState} from "react"
import {ActionContext} from "../../../../context/ActionContextProvider"

const BereicheItem = ({risikoortListEntry}) => {
    const {triggerAction} = useContext(ActionContext)
    const [anchorEl, setAnchorEl] = useState(null)
    const containerRef = useRef(null)
    const open = Boolean(anchorEl)

    const onHover = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorEl(null)
    }

    const handleEdit = (risikoort, bereich) => {
        closeMenu()
        triggerAction("SELECT_BEREICH", {risikoort, bereich})
    }

    const handleDelete = (bereich) => {
        closeMenu()
        triggerAction("DELETE_BEREICH", bereich)
    }

    const handleCreate = () => {
        closeMenu()
        triggerAction("CREATE_BEREICH")
    }

    return (
        <>
            <Button
                ref={containerRef}
                onMouseEnter={onHover}
                variant="contained"
                endIcon={<ExpandMoreIcon />}>
                <Typography>
                    {risikoortListEntry?.risikoort?.risikoortName}
                </Typography>
            </Button>
            <Menu
                id={`name-actions-menu`}
                anchorEl={anchorEl}
                open={open}
                onClose={closeMenu}
                slotProps={{
                    paper: {onMouseLeave: closeMenu},
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}>
                {risikoortListEntry?.bereichList?.map((bereich, key) => (
                    <MenuItem key={bereich?.modelId}>
                        <Grid
                            container
                            spacing={1}
                            alignItems="center">
                            <Grid item>
                                {bereich?.name ?? `Bereich ${key}`}{" "}
                            </Grid>
                            <Grid item>
                                <IconButton
                                    onClick={() =>
                                        handleEdit(
                                            risikoortListEntry.risikoort,
                                            bereich,
                                        )
                                    }>
                                    <Edit />
                                </IconButton>
                                {risikoortListEntry.bereichList?.length > 1 && (
                                    <IconButton
                                        onClick={() => handleDelete(bereich)}>
                                        <Delete />
                                    </IconButton>
                                )}
                            </Grid>
                        </Grid>
                    </MenuItem>
                ))}
                <MenuItem>
                    <Button
                        onClick={handleCreate}
                        startIcon={<AddIcon />}>
                        <Typography>Bereich</Typography>
                    </Button>
                </MenuItem>
            </Menu>
        </>
    )
}

export default BereicheItem
